import router from '../../router/router';

// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

const state = {

    currentPosition : 1
};

const mutations = {

    changePosition( state, data ){

        console.log( 'input data: ', data );
        switch( data.direction ){

            case 'forwards':

                if( state.currentPosition < 10 ) state.currentPosition++;
                else console.log( 'out of bounds!!' );
                break;
            case 'backwards':

                if( state.currentPosition > 1 ) state.currentPosition--;
                else console.log( 'out of bounds!!' );
                break;
            case 'clear':

                state.currentPosition = 1;
                break;
            default:

                console.log( 'not correct input' );
                break;
        }
    }
};

const actions = {

    changePosition( { commit }, data ){

        commit( 'changePosition', data );
    }
};

const getters = {

    currentPosition : state => state.currentPosition
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};